<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 21/02/2018-->
<!--//Time: 11:19-->

<template>
    <nav :class="pagination_class">
        <div class="align-self-center">
            <div :class="classes.select.class"
                 class="page-paginate--rows-select d-none d-md-inline-block"
            >
                <select :id="page_id"
                        :class="classes.select.element"
                        class="no-bg d-inline-block"
                        v-model="selectedRowsPerPage"
                >
                    <option :class="classes.select.element_option"
                            v-for="select_option in select_options"
                            :value="select_option"
                    >{{select_option}}
                    </option>
                </select>
                <label :class="classes.select.label"
                       class="mx-1 my-0 d-inline-block"
                       :for="page_id"
                >Results</label>
            </div>
            <!--index position-->
            <div :class="classes.index"
                 class="page-paginate--index"
            >
                <span class="align-middle">{{page_start + 1}} - {{(page_start + page_limit > pages_length)?pages_length:parseInt(page_start + page_limit)}} of {{pages_length}}</span>
            </div>
        </div>
        <!--prev next buttons-->
        <div :class="classes.button.class"
             class="page-paginate--buttons"
        >
            <div class="d-flex justify-content-end align-content-center">
                <div class=" btn btn-primary btn-sm mr-1 m-0" @click="movePage(false)">
                    <div class="prev cursor--pointer"
                         :class="setButtonClasses(false,'previous')"
                    >
                        <i class="fa fa-chevron-left"></i>
                    </div>
                </div>
                <div class=" btn btn-primary btn-sm m-0" @click="movePage(true)">
                    <div class="next cursor--pointer"
                         :class="setButtonClasses(true,'next')"

                    >
                        <i class="fa fa-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
	export default {
		name: "pagination",
		components: {},
		props: [
			'position',
			'element_classes',
			'page_id',
			'page_start',
			'page_end',
			'page_limit',
			'pages_length',
			'callback_name',
			'callback_data',
			'select_options',
			'pageinate_class'
		],
		created() {
		},
		destroyed() {
		},
		mounted() {
			this.selectedRowsPerPage = this.page_limit;
			if (typeof this.callback_name !== 'undefined' && this.callback_name !== null) {
				this.event_callback_name = this.callback_name;
			}
			if (typeof this.callback_data !== 'undefined' && this.callback_data !== null) {
				this.event_callback_data = this.callback_data;
			}
			if (typeof this.element_classes !== 'undefined' && this.element_classes !== null) {
				this.classes = this.element_classes;
			}
			if (typeof this.position !== 'undefined' && this.position !== null) {
				// this.paginate_position = this.position;

				if(this.position == 'start'){
					this.paginate_position = 'justify-content-start'
				}
				else if(this.position == 'center'){
					this.paginate_position = 'justify-content-center'
				}
				else if(this.position == 'end'){
					this.paginate_position = 'justify-content-end'
				}
			}
		},
		data() {
			return {
				paginate_position:'justify-content-end',
				classes: {
					select: {
						label: '',
						element: '',
						element_option: '',
						class: ''
					},
					button: {
						class: '',
						previous: '',
						next: ''
					},
					index: ''
				},
				selectedRowsPerPage: 0,
				event_callback_name: 'pageinate_event',
				event_callback_data: {}
			}
		},
		methods: {
			setButtonClasses(setButton, position) {
				let items = [
					(this.disableButtons(setButton)) ? 'd-none' : 'd-inline-block',
					this.classes.button[position]
				], result = items.join(' ');
// console.log('result',result);
				return result;

			},
			disableButtons(increment) {
				return false;
				// if (increment) {
				//     return this.page_start + this.page_limit > this.pages_length
				// } else {
				//     return this.page_start - this.page_limit < 0
				// }
			},
			movePage(up) {
				this.$emit(this.event_callback_name, {
					value: up,
					action: 'next',
					records: this.event_callback_data
				});
			}
		},
		computed: {
		    pagination_class(){
                if (this.pageinate_class && this.pageinate_class !== ''){
                    return this.pageinate_class;
                }

		        let _default = 'w-100 w-md-66 page-paginate d-flex  flex-row align-items-center';
		        _default += ' ' + this.paginate_position;
		        return _default;
            }
        },
		watch: {
			page_limit(page) {
				let valuePosition = this.select_options.indexOf(page);

				this.$nextTick(function () {
					document.getElementById(this.page_id).options[valuePosition].selected = 'selected';
				});
			},
			selectedRowsPerPage: function (page) {
				this.$emit(this.event_callback_name, {
					value: page,
					action: 'rows',
					records: this.event_callback_data
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/Pagination.vue